import { render, staticRenderFns } from "./Pariciones.vue?vue&type=template&id=482e5309&scoped=true"
import script from "./Pariciones.vue?vue&type=script&lang=js"
export * from "./Pariciones.vue?vue&type=script&lang=js"
import style0 from "./Pariciones.vue?vue&type=style&index=0&id=482e5309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e5309",
  null
  
)

export default component.exports